module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"report_button":"Report and block"}}')
  delete Component.options._Ctor
}
